<template>
  <component
    :is="isCardReviews ? 'div' : 'button'"
    class="flex items-center"
    :class="{ 'cursor-pointer' : !isCardReviews }"
    @click="scrollToReviews"
  >
    <ReviewsStars
      :rating="ratingToShow.averageRating"
    />
    <component
      :is="isCardReviews ? 'span' : 'a'"
      class="text-EXPONDO-secondary"
      :class="{ 'mx-4 underline': !isCardReviews, 'ml-1': isCardReviews }"
    >
      {{ isCardReviews ?
        `(${ratingToShow.count})`
        :
        $t('amount-of-reviews', { count: ratingToShow.count, _reviews_amount_: ratingToShow.count })
      }}
    </component>
    <span
      v-if="!ratingToShow.count"
      class="text-sm"
    >
      {{ $t('be-first-to-review') }}
    </span>
    <AggregateReviewSchema
      v-if="showSchema"
      :reviews-count="ratingToShow.count"
      :rating="ratingToShow.averageRating"
    />
  </component>
</template>

<script lang="ts">

import { LINK_TYPE } from '~~/types/components/Link/LinkType';
import type { ProductRating } from '~~/types/product/attribute/ProductReview';
import buildProductRating from '~~/helpers/product/buildProductRating';
import { scrollToSection } from '~~/helpers/scroll/scrollToSection';
import { RATING_REVIEWS_SELECTOR } from '~~/constants/pagination';

export default defineComponent({
  name: 'ProductAverageReview',

  props: {
    rating: {
      type: Object as PropType<ProductRating>,
      default: () => {

        return null;

      },
    },
    isCardReviews: {
      type: Boolean,
      default: false,
    },
    showSchema: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {

    const { stickyAnchorNavHeight } = useAnchorNavigationStore();
    // needed additional px to enter section and make it active in intersection observer for anchor nav
    const additionalPxToEnterSection = 1;

    const scrollToReviews = () => {

      if (!props.isCardReviews) {

        scrollToSection(RATING_REVIEWS_SELECTOR, -stickyAnchorNavHeight.value + additionalPxToEnterSection);

      }

    };
    const ratingToShow = computed(() => {

      return buildProductRating({
        averageRating: props.rating?.averageRating,
        count: props.rating?.count,
        defaultTo0: true,
      });

    });

    return {
      ratingToShow,
      LINK_TYPE,
      scrollToReviews,
    };

  },
});

</script>
